import { render, staticRenderFns } from "./mProve.vue?vue&type=template&id=062fbcda&class=p-1&"
import script from "./mProve.vue?vue&type=script&lang=js&"
export * from "./mProve.vue?vue&type=script&lang=js&"
import style0 from "./mProve.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/mProve.vue
// module id = null
// module chunks = 